import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import './plugins/multiselect';
import App from './App.vue';
import router from './router';
import store from './store';

const token = localStorage.getItem('userToken');
if (token) {
  store.commit('setToken', token);
}

Vue.use(require('vue-moment'));

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
